export class DateClass {
    constructor(date) {
        this.date = new Date(date) || ''
    }

    getYear() {
        return this.date.toISOString().split("-")[0]
    }
    getYearFrom(date) {
        return date.toISOString().split("-")[0]
    }
}
